// The UTC wall-clock time of a date, read as local time. Same result as
// new Date(new Date(date).toLocaleString('en-US', { timeZone: 'UTC' })),
// which costs ~0.02 ms per call and froze lists of 900 events for 240 ms.
export const parseUTCWallClock = date => {
    const d = new Date(date);
    return new Date(
        d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(),
        d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds()
    );
};
